import { render, staticRenderFns } from "./DeliverySpotsList.vue?vue&type=template&id=1a3f7123&scoped=true&"
import script from "./DeliverySpotsList.vue?vue&type=script&lang=js&"
export * from "./DeliverySpotsList.vue?vue&type=script&lang=js&"
import style0 from "./DeliverySpotsList.vue?vue&type=style&index=0&id=1a3f7123&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3f7123",
  null
  
)

export default component.exports